const Builder = require('../BuilderBase');
const HiddenFor = require('../HiddenFor');
const CustomizableVisibility = require('../CustomizableVisibility');

module.exports = class FormButton extends Builder {
    constructor(title, properties) {
        super('formButton_FormButton', title, properties);
    }

    /**
     *
     * @param {object} properties
     * @param {string} properties.title
     * @param {boolean} properties.isTabAccess
     * @param {string} properties.accessTargetId
     * @param {boolean} properties.readOnly
     */
    customizableVisibility(properties) {
        let modifier = new CustomizableVisibility({ isTabAccess: false, ...properties });
        this.addChildBlock(modifier, 'securityModifier');
        return this;
    }

    hiddenFor(role) {
        let hiddenFor = new HiddenFor(role);
        this.addChildBlock(hiddenFor, 'securityModifier');
        return this;
    }
};
